import type { ROUTE_ME } from '~/contexts/me/router/routes'

import { EActivityFilter, EFeedMode, EFeedSort } from '~/features-shared/content/stores/contents'

import { useLocalStorageManager } from '~/features-generic/config-manager/utils/local-storage-manager'

/**
 * Last me>draft feed mode state (large, compact or timeline)
 * Saved in LocalStorage
 */
export const useDraftFeedMode = createGlobalState(
  () => useLocalStorageManager<EFeedMode>('feed_mode-draft', EFeedMode.Compact),
)

/**
 * Last me>draft feed sort state (creation or update)
 * Saved in LocalStorage
 */
export const useDraftFeedSort = createGlobalState(
  () => useLocalStorageManager<EFeedSort>('feed_sort-draft', EFeedSort.Update),
)

/**
 * Last me>contributions feed mode state (large, compact or timeline)
 * Saved in LocalStorage
 */
export const useContributionFeedMode = createGlobalState(
  () => useLocalStorageManager<EFeedMode>('feed_mode-contribution', EFeedMode.Compact),
)

/**
 * Last me>contributions feed sort state (creation or update)
 * Saved in LocalStorage
 */
export const useContributionFeedSort = createGlobalState(
  () => useLocalStorageManager<EFeedSort>('feed_sort-contribution', EFeedSort.Creation),
)

/**
 * Keep in memory the last filter use in me>netwotk-activity>user
 */
export const useMeActivityFilter = createGlobalState(() => ref(EActivityFilter.All))

/**
 * Name of the last visited "me" page (contributions, drafts, etc..) - or "".
 * Saved in LocalStorage
 */
export const useLastVisitedMyUniverse = createGlobalState(
  () => useLocalStorageManager<ROUTE_ME | null>('last_visited_my-universe', null),
)
